import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

function Yhteystiedot() {
  return (
    <Layout>
      <SEO
        keywords={[
          `Glue`,
          `Team`,
          `yhteystiedot`,
          `contact`,
          `Henry`,
          `Lehtonen`,
        ]}
        title="Yhteystiedot"
      />

      <section className="flex flex-col items-center md:flex-row">
        <p className="w-full h-64">
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Palovuorentie+35,+Rusko,+Finland&amp;aq=0&amp;oq=palovuorentie+35+rusko&amp;sll=37.0625,-95.677068&amp;sspn=60.158465,135.263672&amp;ie=UTF8&amp;hq=&amp;hnear=Palovuorentie+35,+Rusko,+Finland&amp;ll=60.567867,22.233919&amp;spn=0.018537,0.066047&amp;t=m&amp;z=14&amp;output=embed"
          ></iframe>
          <br />
          <small>
            <a
              href="http://maps.google.fi/maps?f=q&amp;source=embed&amp;hl=fi&amp;geocode=&amp;q=palovuorentie+35+rusko&amp;aq=&amp;sll=60.548502,22.262421&amp;sspn=0.430798,1.674042&amp;ie=UTF8&amp;hq=&amp;hnear=Palovuorentie+35,+Rusko&amp;ll=60.567867,22.233919&amp;spn=0.007117,0.026157&amp;t=m&amp;z=14"
              className="text-right float-right underline hover:no-underline hover:text-gray-700"
            >
              Näytä suurempi kartta
            </a>
          </small>
        </p>
      </section>
      <div className="mt-12">
        <p>
          <ul>
            <li>Henry Lehtonen</li>
            <li>Palovuorentie 35, 21290 Rusko</li>
            <li>
              <a href="tel:+358404180160" className="hover:underline">
                040 4180160
              </a>
            </li>
            <li>
              <a href="mailto:posti@glue-team.fi" className="hover:underline">
                posti@glue-team.fi
              </a>
            </li>
          </ul>
        </p>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query {
    henryImg: file(relativePath: { eq: "henry.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default Yhteystiedot;
